module.exports = __webpack_public_path__ + "c8ae3e93ae16983c73a68cf537557de2.woff2";